import {
  Box,
  Typography,
  CircularProgress,
  useMediaQuery,
} from '@mui/material';
import { CustomButton } from '../../../v2/MUI_custom_component';
import dayjs from 'dayjs';
import IllustrationWrapper from '../../Illustrration/IllustrationWrapper';
import NoDataFoundSvg from '../../Illustrration/components/NoDataFoundSvg';
import { toCapitalized } from '../../../v2/Utils/Capitalize';
import { useNavigate } from 'react-router-dom';

const InvoiceCard = ({
  invoiceData,
  loading,
  isViewAttachedDPData,
  selectedStatus = [],
}) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 1200px)');
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {invoiceData && invoiceData.length > 0 ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            borderRadius: 2,
            px: 2,
            backgroundColor: '#fff',
          }}
        >
          {invoiceData.map((invoice, index) => (
            <Box
              key={invoice.order_id || index}
              sx={{
                borderBottom:
                  index < invoiceData.length - 1 ? '1px solid #D9D9D9' : 'none',
                py: 2,
                display: 'flex',
                // gap: { xs: 0.5, md: 0 },
                flexDirection: { xs: 'column', md: 'row' },
              }}
            >
              <Box
                sx={{
                  borderRight: invoice?.company_name
                    ? { md: '1px solid #D9D9D9' }
                    : 'none',
                  display: 'flex',
                  flexDirection: { xs: 'row', md: 'column' },
                  minWidth: { md: '250px' },
                  gap: 1,
                  justifyContent: { xs: 'space-between', md: 'flex-start' },
                  alignItems: 'flex-start',
                  pr: { md: 2 },
                }}
              >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Typography variant='bodyL'>
                    {dayjs(invoice.date_of_invoice).format('DD MMM YYYY')}
                  </Typography>
                  {invoice?.company_name && (
                    <Box
                      sx={{
                        display: { xs: 'flex', md: 'none' },
                        flexDirection: { xs: 'row', md: 'column' },
                        gap: 1,
                        alignItems: { xs: 'center', md: 'flex-start' },
                      }}
                    >
                      <Typography
                        variant='labelM'
                        sx={{ color: '#666' }}
                      >
                        Ship to Party
                      </Typography>
                      <Typography
                        variant='p3'
                        sx={{ fontWeight: 600 }}
                      >
                        {toCapitalized(invoice?.company_name)}
                      </Typography>
                    </Box>
                  )}
                </Box>
                {invoice?.order_id && (
                  <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: { xs: 'row', md: 'row' },
                        gap: 2,
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: { xs: 'row', md: 'row' },
                          gap: 1,
                          alignItems: { xs: 'center', md: 'flex-start' },
                        }}
                      >
                        <Typography
                          variant='labelM'
                          sx={{ color: '#666' }}
                        >
                          Order ID
                        </Typography>
                        <Typography
                          variant='p3'
                          sx={{ fontWeight: 600 }}
                        >
                          {invoice.order_id}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>

              <Box
                sx={{
                  width: '100%',
                  pl: { md: 2 },
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'end',
                    width: '100%',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: { xs: 'column', md: 'row' },
                      gap: { xs: 0.5, md: 4 },
                    }}
                  >
                    {invoice?.company_name && (
                      <Box
                        sx={{
                          display: { xs: 'none', md: 'flex' },
                          flexDirection: { xs: 'row', md: 'column' },
                          gap: { xs: 2, md: 1 },
                        }}
                      >
                        <Typography
                          variant='labelM'
                          sx={{
                            color: '#666',
                            minWidth: { xs: '80px', md: '100px' },
                          }}
                        >
                          Ship to Party
                        </Typography>
                        <Typography variant='p3'>
                          {toCapitalized(invoice?.company_name)}
                        </Typography>
                      </Box>
                    )}
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: { xs: 'row', md: 'column' },
                        gap: { xs: 2, md: 1 },
                      }}
                    >
                      <Typography
                        variant='labelM'
                        sx={{
                          color: '#666',
                          minWidth: { xs: '80px', md: '100px' },
                        }}
                      >
                        {invoice?.quantity[0]?.label || 'Invoice Qty.'}
                      </Typography>
                      <Typography
                        variant='p3'
                        noWrap
                      >
                        {invoice?.quantity[0]?.value || '-'}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: { xs: 'row', md: 'column' },
                        gap: { xs: 2, md: 1 },
                      }}
                    >
                      <Typography
                        variant='labelM'
                        sx={{
                          color: '#666',
                          minWidth: { xs: '80px', md: '100px' },
                        }}
                      >
                        Invoice No.
                      </Typography>
                      <Typography variant='p3'>
                        {invoice?.invoice_no}
                      </Typography>
                    </Box>
                  </Box>
                  {invoice?.invoice_no && (
                    <Box
                      sx={{
                        width: { xs: '100%', md: 'auto' },
                        display: 'flex',
                        justifyContent: { xs: 'end', md: 'center' },
                      }}
                    >
                      <CustomButton
                        label='View Details'
                        variant='text'
                        color='primary'
                        onClick={() => {
                          navigate(`/invoice-detail/${invoice.invoice_id}`);
                        }}
                        size={isMobile ? 'small' : 'medium'}
                      />
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
          ))}
          {/* Loader */}
          {loading && invoiceData.length > 0 && (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
              <CircularProgress size={24} />
            </Box>
          )}
        </Box>
      ) : null}

      {/* loaders */}
      {loading && invoiceData.length === 0 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            p: 4,
          }}
        >
          <CircularProgress />
        </Box>
      )}

      {/* Empty state */}
      {!loading && (!invoiceData || invoiceData.length === 0) && (
        <Box
          sx={{
            mt: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 4,
          }}
        >
          <IllustrationWrapper
            illustration={<NoDataFoundSvg />}
            title='No Invoice found. '
            subtitle={
              selectedStatus.length > 0
                ? 'Try adjusting your filters.'
                : 'No Invoices available yet.'
            }
          />
        </Box>
      )}
    </Box>
  );
};

export default InvoiceCard;
